/* artgraph ブログ束「exhibition」— 閲覧時に会期を判定し直す。

   🔴 「開催中」は本文に書き込まない。日付だけを data-periods に持ち、
      ①毎日 build_exhibition_articles.py が台帳から本文を作り直す
      ②この JS が閲覧時にもう一度判定する
      の2重で、定期実行が1回飛んでも表示が嘘にならないようにする。
   🔴 出し入れは display='block' / 'none'。display='' は CSS の none に戻るだけで永久に出ない。 */
(function () {
  'use strict';

  var LABEL = { open: '開催中', soon: 'まもなく終了', upcoming: 'これから', between: '展示替え中', ended: '終了' };
  var SOON = 14 * 86400000;

  function day(s) { var t = new Date(s + 'T00:00:00'); t.setHours(0, 0, 0, 0); return t; }

  function judge(periods, today) {
    var start = day(periods[0][0]);
    var end = day(periods[periods.length - 1][1]);
    if (today > end) return { st: 'ended', end: end };
    if (today < start) return { st: 'upcoming', end: end };
    var live = periods.filter(function (p) { return day(p[0]) <= today && today <= day(p[1]); });
    if (!live.length) return { st: 'between', end: end };
    var soonest = Math.min.apply(null, live.map(function (p) { return day(p[1]).getTime(); }));
    return { st: (soonest - today.getTime() <= SOON) ? 'soon' : 'open', end: end };
  }

  function periodsOf(el) {
    try { return JSON.parse(el.getAttribute('data-periods')) || []; } catch (e) { return []; }
  }

  function paint(badge, st, base) {
    if (!badge) return;
    badge.textContent = LABEL[st];
    badge.className = base + (st === 'soon' ? ' is-soon' : st === 'ended' ? ' is-ended' : '');
  }

  var today = new Date();
  today.setHours(0, 0, 0, 0);

  /* ── 記事（展覧会1件）───────────────────────────── */
  var art = document.querySelector('.agxa[data-periods]');
  if (art) {
    var ps = periodsOf(art);
    if (ps.length) {
      var r = judge(ps, today);
      paint(art.querySelector('.agxa-state'), r.st, 'agxa-state');
      var left = art.querySelector('.agxa-left');
      if (left) {
        var days = Math.round((r.end - today) / 86400000);
        left.textContent = (r.st === 'open' || r.st === 'soon') && days >= 0 ? ('あと' + days + '日') : '';
      }
      var warn = art.querySelector('.agxa-warn');
      if (warn) warn.style.display = (r.st === 'ended') ? 'block' : 'none';
    }
  }

  /* ── 一覧（束のトップ）会期の終わりが近い順。終了したものは末尾へ ── */
  var grid = document.querySelector('.agxc-grid');
  if (grid) {
    var cards = [].slice.call(grid.querySelectorAll('.agxc-card[data-periods]'));
    var live = 0;
    var ranked = cards.map(function (c, i) {
      var p = periodsOf(c);
      if (!p.length) return { c: c, k: [2, 0, i] };
      var j = judge(p, today);
      paint(c.querySelector('.agxc-state'), j.st, 'agxc-state');
      if (j.st !== 'ended') live++;
      return { c: c, k: [j.st === 'ended' ? 1 : 0, j.end.getTime(), i] };
    });
    ranked.sort(function (a, b) {
      return a.k[0] - b.k[0] || a.k[1] - b.k[1] || a.k[2] - b.k[2];
    });
    ranked.forEach(function (x) { grid.appendChild(x.c); });
    var count = document.querySelector('[data-agxc-count]');
    if (count) count.textContent = '開催中・これから ' + live + '件／全' + cards.length + '件';
  }

  document.documentElement.classList.add('agx-ready');
})();
